import React from 'react'

const Error = () => {
  const al=()=>{
    alert(' API fatching 404 ERROR ')
  }
  return (
   al()
  )
}

export default Error